import React, { Component } from 'react';
//import { render } from 'react-dom';
import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
// import './TextEditor.css'






function uploadImageCallBack(file) {
  return new Promise(
    (resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.imgur.com/3/image');
      xhr.setRequestHeader('Authorization', 'Client-ID 8f7bdb260c4182c');
      const data = new FormData();
      data.append('image', file);
      xhr.send(data);
      xhr.addEventListener('load', () => {
        const response = JSON.parse(xhr.responseText);
        console.log(response)
        resolve(response);
      });
      xhr.addEventListener('error', () => {
        const error = JSON.parse(xhr.responseText);
        console.log(error)
        reject(error);
      });
    }
  );
}


class EditorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
    };
  }

  onEditorStateChange: Function = (editorState) => {
    // console.log(editorState)
    this.setState({
      editorState,
    });
  };

  render() {
    const { editorState } = this.state;
    return <div className='editor' style={{color: "red", backgroundColor: "#CAB9CC" ,height: '500px'}} >
      <Editor
        editorState={editorState}
        onEditorStateChange={this.onEditorStateChange}
        toolbar={{
          inline: { inDropdown: true },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
          link: { inDropdown: true },
          history: { inDropdown: true },
          image: { uploadCallback: uploadImageCallBack, alt: { present: true, mandatory: true } },
        }}
      />
    </div>
  }
}






const TextEditor = () => (
  <div>
    <div style={{color: "red", backgroundColor: "lightblue"}}>
      <br />
      <h2>WorkPad</h2>
      <br />
    </div>
    <EditorContainer />
    <br />
    <h2><b>Steps to use this WordPad</b></h2>
    <br />
    <h4>First of all copy the content which you want code or text</h4>
    <h4>The paste the content and align as per your needs</h4>
    <h4>You can also embedded you yoututbe video and photos to make it beautiful</h4>
    <h4>Enjoy Reading!!</h4>
  </div>
);

export default TextEditor;